import { ModalContent, Typography } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { ModalWithDefaultZIndex } from '@/styles';
import { colors, responsive } from '@/utils';

export const StyledModal = styled(ModalWithDefaultZIndex)<{ $fullWidth?: boolean }>`
  min-width: ${({ $fullWidth }) => (($fullWidth ?? true) ? '75vw' : 'unset')};
  min-height: 50vh;
`;

export const StyledModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledForm = styled.form`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
  min-width: 51.25rem;
  width: 100%;
`;

export const BargeControlGrid = styled.div`
  display: grid;
  gap: ${responsive.spacing['2xlarge']};
  grid-template-columns: repeat(auto-fill, minmax(21rem, 4fr));
  width: 100%;
`;

export const BargeControlGioGrid = styled.div`
  display: grid;
  gap: ${responsive.spacing['2xlarge']};
  grid-template-columns: repeat(2, 1fr);
  align-content: start;
  width: 100%;
`;

export const NoWrapTypography = styled(Typography)`
  text-wrap: nowrap;
`;

/* Ruler numbers in the silo and tank illustrations: quiet neutral, smallest label size so a tall
   vessel still reads cleanly. Right-aligned because the ruler sits to the left of the vessel. */
export const StyledRulerText = styled.text`
  fill: ${colors.text.neutral.on.soft.contrast[50]};
  text-anchor: end;
  font-family: ${responsive.font.family.label};
  font-size: ${responsive.font.size.xsmall};
  font-weight: ${responsive.font.weight.regular};
`;

/* Alarm pill text: `medium` matches the body_medium a default-size Badge renders, so the pills
   read at the same size as the alarm badges above the illustration.
   `fill` is set per element because it follows the pill's severity. */
export const StyledAlarmLabelText = styled.text`
  font-family: ${responsive.font.family.label};
  font-size: ${responsive.font.size.medium};
  font-weight: ${responsive.font.weight.medium};
`;
